import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    historiaClinica: [],
    idHistoriaClinica: null,
  },

  getters: {
    getHistoriaClinica: (state) => state.historiaClinica,

    getIdHistoriaClinica: (state) => state.idHistoriaClinica,
  },

  mutations: {
    SET_HISTORIA_CLINICA(state, historiaClinica) {
      state.historiaClinica = historiaClinica;
    },

    SET_ID_HISTORIA_CLINICA(state, idHistoriaClinica) {
      state.idHistoriaClinica = idHistoriaClinica;
    },
  },

  actions: {
    async fetchHistoriasClinicas({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/historiasclinicas/')
        .then((response) => {
          commit('SET_HISTORIA_CLINICA', response.data.data);
        });
    },

    async fetchHistoriasClinicasByExpediente({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/historiasclinicas`)
        .then((response) => {
          commit('SET_HISTORIA_CLINICA', response.data.data);
        });
    },

    async saveHistoriaClinica({ commit }, historiaClinica) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${historiaClinica.idExpediente}/historiasclinicas`, historiaClinica)
        .then((response) => {
          commit('SET_ID_HISTORIA_CLINICA', response.data.data[0].ID);
        });
    },

    async updateHistoriaClinica(_, historiaClinica) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/expedientes/${historiaClinica.fk_idExpediente}/historiasclinicas/${historiaClinica.fk_idHistoriaClinica}`,
          historiaClinica,
        );
    },
  },
};
